var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "help-case-upload-dialog-content" },
    [
      !_vm.loading
        ? _c(
            "pui-form",
            {
              on: {
                reset: _vm.onReset,
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex mt-8" },
                [
                  _c("pui-icon", {
                    attrs: { "icon-name": "warning", "icon-color": "#fda428" }
                  }),
                  _c("div", { staticClass: "pl-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("uploadDialog.backfillDataWarning", {
                            selectedSiteName: _vm.selectedSiteName
                          })
                        ) +
                        " "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "grid grid-cols-2" },
                [
                  _c(
                    "pui-form-group",
                    {
                      staticStyle: { height: "92px" },
                      attrs: {
                        label: _vm.$t("uploadDialog.chooseBackfillUploadFile")
                      }
                    },
                    [
                      _c(
                        "pui-file-upload",
                        {
                          attrs: {
                            "on-change-callback": _vm.onChangeCallback,
                            label: _vm.$t("common.fileUpload")
                          },
                          on: { "puifileupload:removed": _vm.onRemove }
                        },
                        [
                          _c("pui-icon", {
                            attrs: {
                              slot: "left",
                              "icon-name": "icon-add-attachment"
                            },
                            slot: "left"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showResponseIcon
                    ? _c(
                        "div",
                        { staticClass: "flex items-end justify-start" },
                        [
                          _vm.uploadSuccessful
                            ? _c("pui-icon", {
                                attrs: {
                                  "icon-color": "green",
                                  "icon-name": "check",
                                  size: "5rem"
                                }
                              })
                            : _c("pui-icon", {
                                attrs: {
                                  "icon-color": "red",
                                  "icon-name": "close",
                                  size: "5rem"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex flex-row justify-end mt-16" },
                [
                  _c(
                    "pui-button",
                    {
                      staticClass: "mr-2",
                      attrs: { state: "secondary", type: "reset" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c(
                    "pui-button",
                    {
                      attrs: {
                        disabled: !_vm.formFile,
                        state: "primary",
                        type: "submit"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.submit")) + " ")]
                  )
                ],
                1
              )
            ]
          )
        : _c("pui-loader-spinner", {
            attrs: {
              message: _vm.$t("uploadDialog.uploadPendingMessage"),
              "min-height": "92px",
              size: "60px",
              title: _vm.$t("common.pleaseWait")
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }